module.exports = __webpack_public_path__ + "static/img/img_logo.c0127652.png";